export const SALARY_APPROVAL_STATUS = {
  PENDING: "На рассмотрении",
  APPROVED: "Согласован",
  REJECTED: "Отклонено",
};

export const normalizeSalaryApprovalStatus = (status) => {
  switch ((status || "").toLowerCase()) {
    case "approved":
    case "согласован":
    case "согласовано":
      return SALARY_APPROVAL_STATUS.APPROVED;
    case "rejected":
    case "declined":
    case "отклонено":
    case "не согласован":
      return SALARY_APPROVAL_STATUS.REJECTED;
    case "pending":
    case "на рассмотрении":
    default:
      return SALARY_APPROVAL_STATUS.PENDING;
  }
};

export const getSalaryApprovalPartyStatuses = (approval) => {
  const statuses = (approval?.steps || []).map((step) =>
    normalizeSalaryApprovalStatus(step.status),
  );

  if (approval?.company_approval?.approver) {
    statuses.push(
      approval.company_approval.status
        ? normalizeSalaryApprovalStatus(approval.company_approval.status)
        : SALARY_APPROVAL_STATUS.PENDING,
    );
  }

  return statuses;
};

export const isSalaryApprovalFullyApproved = (approval) => {
  if (!approval) return false;

  const statuses = getSalaryApprovalPartyStatuses(approval);
  if (statuses.length > 0) {
    return statuses.every(
      (status) => status === SALARY_APPROVAL_STATUS.APPROVED,
    );
  }

  return (
    normalizeSalaryApprovalStatus(approval.status) ===
      SALARY_APPROVAL_STATUS.APPROVED || Boolean(approval.approved_at)
  );
};

export const canDeleteSalaryApproval = (approval, { isAdms = false } = {}) => {
  if (!approval?.id) return false;
  if (isAdms) return true;
  return !isSalaryApprovalFullyApproved(approval);
};
